
import Saved from "./saved/onLoad"
import FilterBar from "./filter_bar/onLoad"

const onLoad = () => {
  Saved.onLoad()
  FilterBar.onLoad()
}

export default {onLoad}
